// @flow
import {observable, toJS, runInAction} from 'mobx'
import * as cf from 'cf'
import parseRawGrid from 'utils/parseRawGrid'
import type {Grid, GridName, FormattedGrid} from '../entities'
import componentStore from './components'

type GridStore = {
  gridName: GridName,
  _data: Grid | null,
  gap: number,
  toggleActive: () => void,
  setGap: (gap:number) => void,
  active: boolean,
  formattedGrid: FormattedGrid,
  updateFormattedGrid: (grid:FormattedGrid) => void
}

type Store = {
  [name:GridName]: GridStore
}

const createGridStore = (name:GridName):GridStore => {
  const gridStore:GridStore = observable(({
    gridName: name,
    _data: null,
    gap: 0,
    get active(){
      return gridStore._data ? gridStore._data.active : false
    },
    get formattedGrid():FormattedGrid{
      if(!gridStore._data) return { widths:[], heights:[], components:[], buffer:[] }
      const rawGrid = gridStore._data.content
      const components = componentStore.components
      return parseRawGrid(rawGrid, components)
    },
    setGap: gap => {
      gridStore.gap = gap
    },
    toggleActive(){
      if(!gridStore._data) return
      gridStore._data.active = !gridStore._data.active
    },
    updateFormattedGrid(grid){
      let result:any = Array(grid.heights.length).fill().map(() => Array(grid.widths.length).fill().map(() => '.'))
      grid.components.forEach(row => Array(row.h).fill().forEach((_,y) => Array(row.w).fill().forEach((_,x) => {
          result[y+row.y-1][x+row.x-2] = row.component.gridName
      })))

      result = result
          .map((row, i) => `" ${row.join(' ')} " ${grid.heights[i]}`)
          .join('\n') + `\n/ ${grid.widths.join(' ')}`

      if(!gridStore._data) return
      const data = gridStore._data
      if(gridStore._data.content === result) return
      data.content = result
      data.components = grid.components.map(row => row.component.gridName)
      updateCf()
    }
  }:GridStore))
  return gridStore
}

const store:Store = observable(({
  MOBILE_M: createGridStore('MOBILE_M'),
  MOBILE_L: createGridStore('MOBILE_L'),
  TABLET: createGridStore('TABLET'),
  LAPTOP: createGridStore('LAPTOP'),
  LAPTOP_L: createGridStore('LAPTOP_L'),
  LAPTOP_XL: createGridStore('LAPTOP_XL')
}:Store))

window.gridStore = store


let history = []

function updateCf () {
  let story = cf.getStory()
  history.push(story)
  Object.keys(store).forEach(key => {
    story = {
      ...story, 
      GRID_GAP: {...story.GRID_GAP, [key]: store[key].gap},
      GRID: { ...story.GRID, [key]: toJS(store[key]._data) }
    }
  })
  cf.update(story)
}

window.goBack = () => {
  let story = history.pop()
  console.log('back', story)
  if(!story) return
  cf.update(story)
  runInAction(() => {
    Object.keys(story.GRID)
      .forEach(id => {
        const grid = story.GRID[id]
        const gap = story.GRID_GAP[id]
        store[id]._data = grid
        store[id].gap = gap
      })
  })
}

cf.addChangeListener(story => {
  Object.keys(story.GRID)
    .forEach(id => {
      const grid = story.GRID[id]
      const gap = story.GRID_GAP[id]
      store[id]._data = grid
      store[id].gap = gap
    })
})

export default store


// WEBPACK FOOTER //
// ./src/stores/grid.js